import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import Moment from 'react-moment';
import Link from '../Global/Link';
import ImageHandler from '../../utils/ImageHandler';

// ====

const NewsPosts = (props) => {
  const { posts } = props;

  const dateFormat = 'Do MMMM, YYYY';

  return (
    <section className="row justify-content-center">
      {posts.nodes.map((node) => {
        const item = JSON.parse(node.content);

        return (
          <div className="brand-col col-12 col-md-4" key={item._uid}>
            <div className="card h-100">
              <h3 className="card-header">{item.title}</h3>
              <div className="card-body">
                <p className="small">
                  {item.author ? `Posted by ${item.author} ` : 'Posted '}
                  on <Moment format={dateFormat} date={item.date} />
                </p>
              </div>
              <div className="card-footer text-right">
                <Link to={`/${node.full_slug}`} className="stretched-link">
                  Linky
                </Link>
              </div>
            </div>
          </div>
        );
      })}
    </section>
  );
};

export default NewsPosts;

// ====

NewsPosts.propTypes = {
  posts: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

NewsPosts.defaultProps = {
  posts: null,
};
